import React, { useState } from "react";
import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../services/firebaseConfig"; // ubah jika path config berbeza

const MasterPage = () => {
    const [secretInput, setSecretInput] = useState("");
    const [authenticated, setAuthenticated] = useState(false);
    const [formData, setFormData] = useState({ name: "", phone: "", password: "" });
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");

    const SECRET_KEY = "superadmin123"; // ubah ikut kehendak sebenar

    const handleAuth = () => {
        if (secretInput === SECRET_KEY) {
            setAuthenticated(true);
        } else {
            setMessage("Secret key salah!");
        }
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");

        try {
            const selangorPath = collection(db, "inventori", "selangor", "users");
            const docRef = await addDoc(selangorPath, {
                name: formData.name,
                phone: formData.phone,
                password: formData.password,
                role: "pengarah",
                createDate: serverTimestamp(),
                createBy: "master_page"
            });
            setMessage("Berjaya ");
            setFormData({ name: "", phone: "", password: "" });
        } catch (err) {
            console.error("Ralat tambah pengguna:", err);
            setMessage("Gagal menambah pengguna.");
        } finally {
            setLoading(false);
        }
    };

    if (!authenticated) {
        return (
            <div style={{ padding: 20 }}>
                <h2>Masukkan Secret Key</h2>
                <input
                    type="password"
                    value={secretInput}
                    onChange={(e) => setSecretInput(e.target.value)}
                    placeholder="Secret Key"
                />
                <button onClick={handleAuth}>Masuk</button>
                {message && <p>{message}</p>}
            </div>
        );
    }

    return (
        <div style={{ padding: 20 }}>
            {/* <h2>Tambah Pengarah</h2> */}
            <form onSubmit={handleSubmit}>
                <div>
                    <label>Nama</label>
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div>
                    <label>Phone</label>
                    <input
                        type="text"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div>
                    <label>Pword</label>
                    <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                    />
                </div>
                <button type="submit" disabled={loading}>
                    {loading ? "Hantar..." : "Simpan"}
                </button>
            </form>
            {message && <p>{message}</p>}
        </div>
    );
};

export default MasterPage;
